import { useTranslation, Trans } from "react-i18next";

import rec from '../../img/Home/rec.png'

import Fade from 'react-reveal/Fade'
import Button from "../Button";

import ss1 from '../../img/Home/ss1.svg'
import ss2 from '../../img/Home/ss2.svg'
import ss3 from '../../img/Home/ss3.svg'

function Learn() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <div className="flex flex-col xl:flex-row-reverse gap-[60px] justify-between">
                <div className="xl:max-w-[497px] flex flex-col">
                    <p className="text-[#061A77] font-[500] leading-[1.2] poppins text-[28px] xl:text-[48px]">{t('home.11')}</p>
                    <p className="mt-[20px] poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2] text-[#1A0402]">{t('home.12')}</p>
                    <p className="mt-[8px] xl:mt-[20px] text-[#000000B2] xl:max-w-[298px] text-[14px] inter">{t('home.13')}</p>
                    <div className="mt-[40px] xl:mt-auto"><Button/></div>               
                </div>
                <Fade left><img src={rec} alt="" className="mx-auto xl:mx-0"/></Fade>
            </div>
            <div className="flex flex-col xl:flex-row gap-[60px] justify-between mt-[80px] xl:mt-[140px]">
                <p className="text-[#061A77] font-[500] leading-[1.2] poppins text-[28px] xl:text-[48px] xl:max-w-[413px]">{t('home.14')}</p>
                <div className="xl:w-[703px] flex flex-col gap-[12px]">
                    <div className="bg-[#F0FAF9] rounded-[4px] gap-[25px] xl:gap-[50px] flex flex-col items-start xl:items-center xl:flex-row px-[20px] xl:px-[40px] py-[20px] xl:py-[26px]">
                        <img src={ss1} alt="" /> 
                        <div>
                            <p className="poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2] text-[#1A0402]">{t('home.15')}</p>
                            <p className="mt-[12px] text-[#000000B2] xl:max-w-[507px] text-[14px] inter">{t('home.16')}</p> 
                        </div>
                    </div>
                     <div className="bg-[#F0FAF9] rounded-[4px] gap-[25px] xl:gap-[50px] flex flex-col items-start xl:items-center xl:flex-row px-[20px] xl:px-[40px] py-[20px] xl:py-[26px]">
                        <img src={ss2} alt="" /> 
                        <div>
                            <p className="poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2] text-[#1A0402]">{t('home.17')}</p>
                            <p className="mt-[12px] text-[#000000B2] xl:max-w-[507px] text-[14px] inter">{t('home.18')}</p> 
                        </div>
                    </div>
                     <div className="bg-[#F0FAF9] rounded-[4px] gap-[25px] xl:gap-[50px] flex flex-col items-start xl:items-center xl:flex-row px-[20px] xl:px-[40px] py-[20px] xl:py-[26px]">
                        <img src={ss3} alt="" /> 
                        <div>
                            <p className="poppins text-[16px] xl:text-[20px] font-[500] leading-[1.2] text-[#1A0402]">{t('home.19')}</p>
                            <p className="mt-[12px] text-[#000000B2] xl:max-w-[507px] text-[14px] inter">{t('home.20')}</p> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Learn;
 